module.exports = __webpack_public_path__ + "img/RoutingNumberCheck.661fd986.png";